var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapMarker = function SvgMapMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "3.5rem",
    height: "3.5rem",
    viewBox: "0 0 63.2 63.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary)",
    d: "M47.1,10.9c-8.9-8.6-23-8.3-31.6,0.5c-8.6,8.9-8.3,23,0.5,31.6c4.4,4.3,16.1,15.5,16.1,15.5l15.5-16.1             C56.3,33.7,56,19.5,47.1,10.9z M31.7,38.2c-5.7,0-10.3-4.9-10.3-11c0-6.1,4.6-11,10.3-11s10.3,4.9,10.3,11             C41.9,33.3,37.3,38.2,31.7,38.2z"
  })));
};
export default SvgMapMarker;